export interface MymachineResponse {
    nextPage: string;
    totalCount: number;
    filteredCount: number;
    filterHTML: string;
    items: MymachineItem[] | null;
    schema?: any;
    isCreateCaseAllowed: boolean;
    disabledCreateCaseHeaderText: string;
    disabledCreateCaseBodyText: string;
}

export interface MymachineItem {
    name: string;
    number: string;
    detailLink: string;
    shopLinks: ShopLink[] | null;
    serviceCallModalLink?: string;
    inProduction?: string | false;
    discontinued?: Discontinuation | undefined;
    softwareUpdates?: SoftwareUpdates | undefined;
    image: string;
    isFav: boolean;
    toggleFavUrl: string;
    constructionYear: string;
    subEquipments: string;
    location: string;
    serviceAgreement?: string;
}

export interface Discontinuation {
    type: string;
    extendedSupport: boolean;
    status: string;
    date: string;
    head: string;
    text: string;
    link: string;
    linkText: string;
}

export interface ShopLink {
    link: string;
    shopType: ShopType;
    linkText: string;
    linkTarget?: string;
}

export enum ShopType {
    BENDING = "bending",
    PUNCHING = "punching",
    SPAREPARTS = "spareparts",
}

export interface SoftwareUpdates {
    state: SoftwareUpdatesState;
    label: string;
}

export enum SoftwareUpdatesState {
    INSTALLATION_FAILED = "installation_failed",
    NOT_AVAILABLE_FOR_SUBSCRIPTION = "not_available_for_subscription",
    SUBSCRIBED = "subscribed",
    UNSUBSCRIBED = "unsubscribed",
    UPDATE_AVAILABLE = "update_available",
}
